import type { CloudProvider, Settings } from "./types";
import { DEFAULT_SETTINGS } from "./types";

const STORAGE_KEY = "ideatriage.settings.v1";

export function loadSettings(): Settings {
  if (typeof localStorage === "undefined") return { ...DEFAULT_SETTINGS };
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    const parsed = JSON.parse(raw) as Partial<Settings>;
    return {
      ...DEFAULT_SETTINGS,
      ...parsed,
      apiKeys: { ...(parsed.apiKeys ?? {}) },
    };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveSettings(settings: Settings): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {
    // best-effort; storage may be full or disabled
  }
}

export function setCloudEnabled(settings: Settings, enabled: boolean): Settings {
  const next: Settings = { ...settings, cloudEnabled: enabled };
  saveSettings(next);
  return next;
}

export function setProvider(settings: Settings, provider: CloudProvider): Settings {
  const next: Settings = { ...settings, selectedProvider: provider };
  saveSettings(next);
  return next;
}

export function setApiKey(settings: Settings, provider: CloudProvider, key: string): Settings {
  const trimmed = key.trim();
  const apiKeys = { ...settings.apiKeys };
  if (trimmed.length === 0) {
    delete apiKeys[provider];
  } else {
    apiKeys[provider] = trimmed;
  }
  const next: Settings = { ...settings, apiKeys };
  saveSettings(next);
  return next;
}

export function setHuggingFaceToken(settings: Settings, token: string): Settings {
  const next: Settings = { ...settings, huggingFaceToken: token.trim() };
  saveSettings(next);
  return next;
}

export function setCustomModelUrl(settings: Settings, url: string): Settings {
  const next: Settings = { ...settings, customModelUrl: url.trim() };
  saveSettings(next);
  return next;
}

export function setCustomModelFileName(settings: Settings, fileName: string): Settings {
  const next: Settings = { ...settings, customModelFileName: fileName.trim() };
  saveSettings(next);
  return next;
}

export function resetCustomModel(settings: Settings): Settings {
  const next: Settings = { ...settings, customModelUrl: "", customModelFileName: "" };
  saveSettings(next);
  return next;
}
